<form [formGroup]="registerForm" (ngSubmit)="register()">
    <div class="register-container">
        <div class="title-container">
            <h3 class="title-general">{{ 'compassAd.login.companySection' | translate }}</h3>
            <p [innerHTML]="'compassAd.login.companySectionDescription' | translate"></p>
        </div>
        <div class="title-container">
            <h3>{{ 'compassAd.login.companySection2' | translate }}</h3>
        </div>


        <div class="title-container">
            <h4>{{ 'compassAd.login.contactSection' | translate }}</h4>
        </div>
        <div class="form-container">
            <div class="form-group">
                <mat-form-field appearance="fill">
                    <mat-label>{{ 'compassAd.login.form.companyName' | translate }}</mat-label>
                    <input matInput type="text" formControlName="name" name="name" required>
                </mat-form-field>
                <div class="formError" *ngIf="registerForm.get('name')?.errors?.['required'] && registerForm.get('name')?.touched">
                    {{ 'compassAd.login.errors.companyNameRequired' | translate }}
                </div>
            </div>
            <div class="form-group">
                <div class="phone-row">
                    <mat-form-field appearance="fill" class="dial-code">
                        <mat-label>{{ 'compassAd.login.form.countryCode' | translate }}</mat-label>
                        <input
                            matInput
                            type="text"
                            formControlName="country"
                            [matAutocomplete]="countryAuto"
                            autocomplete="off"
                            required>
                        <mat-autocomplete
                            #countryAuto="matAutocomplete"
                            class="country-autocomplete-panel"
                            [panelWidth]="340"
                            [displayWith]="displayCountry"
                            (optionSelected)="onCountrySelected($event.option.value)">
                            <mat-option
                                *ngFor="let c of filteredCountries$ | async; trackBy: trackByCode"
                                [value]="c">
                                <img
                                    [src]="'/assets/extension-chrome/country-flags/' + c.code + '.svg'"
                                    [alt]="c.code"
                                    class="flag">
                                <span class="country-name">{{ countryName(c) }}</span>
                                <span class="dial">{{ c.dialCode }}</span>
                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>

                    <mat-form-field appearance="fill" class="phone-number">
                        <mat-label>{{ 'compassAd.login.form.phone' | translate }}</mat-label>
                        <input matInput type="tel" inputmode="numeric" formControlName="phone" name="phone" required>
                    </mat-form-field>
                </div>
                <div class="formError" *ngIf="registerForm.get('phone')?.errors?.['required'] && registerForm.get('phone')?.touched">
                    {{ 'compassAd.login.errors.phoneRequired' | translate }}
                </div>
            </div>
        </div>


        <div class="title-container">
            <h4>{{ 'compassAd.login.form.emailCompany' | translate }}</h4>
        </div>

        <div class="form-container">
            <div class="form-group">
                <mat-form-field appearance="fill">
                    <mat-label>{{ 'compassAd.login.form.emailCompany' | translate }}</mat-label>
                    <input matInput type="email" formControlName="email" name="email" required>
                </mat-form-field>
                <div class="formError" *ngIf="registerForm.get('email')?.errors?.['required'] && registerForm.get('email')?.touched">
                    {{ 'compassAd.login.errors.emailRequired' | translate }}
                </div>
            </div>
            <div class="form-group">
                <mat-form-field appearance="fill">
                    <mat-label>{{ 'compassAd.login.form.emailCompanyRepeat' | translate }}</mat-label>
                    <input matInput type="email" formControlName="email_repeat" name="email_repeat">
                </mat-form-field>
                <div class="formError" *ngIf="registerForm.get('email_repeat')?.errors?.['required'] && registerForm.get('email_repeat')?.touched">
                    {{ 'compassAd.login.errors.emailRepeatRequired' | translate }}
                </div>
                <div class="formError" *ngIf="registerForm.get('email_repeat')?.errors?.['email'] && registerForm.get('email_repeat')?.touched">
                    {{ 'compassAd.login.errors.emailRepeatInvalid' | translate }}
                </div>
                <div class="formError" *ngIf="registerForm.get('email_repeat')?.errors?.['emailMismatch'] && registerForm.get('email_repeat')?.touched">
                    {{ 'compassAd.login.errors.emailMismatch' | translate }}
                </div>
            </div>
        </div>
        
        <div class="title-container">
            <h4>{{ 'compassAd.login.form.password' | translate }}</h4>
        </div>
        <div class="form-container">
            <div class="form-group">
                <mat-form-field appearance="fill">
                    <mat-label>{{ 'compassAd.login.form.password' | translate }}</mat-label>
                    <input matInput type="password" formControlName="password" name="password" required>
                </mat-form-field>
                <div class="formError" *ngIf="registerForm.get('password')?.errors?.['required'] && registerForm.get('password')?.touched">
                    {{ 'compassAd.login.errors.passwordRequired' | translate }}
                </div>
            </div>
            <div class="form-group">
                <mat-form-field appearance="fill">
                    <mat-label>{{ 'compassAd.login.form.passwordRepeat' | translate }}</mat-label>
                    <input matInput type="password" formControlName="password_repeat" name="password_repeat" required>
                </mat-form-field>
                <div class="formError" *ngIf="registerForm.get('password_repeat')?.errors?.['required'] && registerForm.get('password_repeat')?.touched">
                    {{ 'compassAd.login.errors.passwordRepeatRequired' | translate }}
                </div>
                <div class="formError" *ngIf="registerForm.get('password_repeat')?.errors?.['passwordMismatch'] && registerForm.get('password_repeat')?.touched">
                    {{ 'compassAd.login.errors.passwordMismatch' | translate }}
                </div>
            </div>
        </div>
        <form [formGroup]="termsForm" autocomplete="off" style="margin-top: 20px;">
            <div class="form-group">
                <mat-checkbox formControlName="terms" required>
                    <span [innerHTML]="('compassAd.login.form.termsHtml' | translate)"></span>
                </mat-checkbox>
                <div class="formError" *ngIf="termsForm.get('terms')?.errors?.['required'] && termsForm.get('terms')?.touched">
                    {{ 'compassAd.login.errors.termsRequired' | translate }}
                </div>
                
            </div>
        </form>
        <div class="footer-container">
            <button mat-raised-button color="primary" type="submit" [disabled]="isLoading" class="button-next">
                <div class="button-next" >
                    <span class="button-text" *ngIf="!isLoading">{{ 'compassAd.login.form.next' | translate }}</span>
                    <span class="button-text" *ngIf="isLoading">{{ 'compassAd.login.form.saving' | translate }}</span>
                    <img src="assets/spinner.gif" class="loading-button" alt="Cargando..." *ngIf="isLoading">
                </div>
            </button>
        </div>
    </div>
</form>
